import axios from "axios";
import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import {
	Benefit,
	CommonDetails,
	EnrollmentSchema,
	HOOEnrollment,
	StandardDetails,
	VEBCommonDetails,
	VEBEnrollmentCommonDetails,
	VEBEnrollmentStandardDetails,
	VEBStandardDetails,
	VEBEnrollmentSchema,
	VEBBenefit,
	KSOPCommonDetails,
	GLICommonDetails,
	StackWholeLifeEnrollment
} from "../../../types/enrollment.types";
import { request } from "../api";

const { post, get, patch, put } = request;
const initialRoute = "member/enrollment";
const updateRoute = "/";

export type AddEnrollmentPayload = {
	standard_details: StandardDetails[];
	common_details: CommonDetails;
};

export type AddKSOPEnrollmentPayload = {
	standard_details: StandardDetails[];
	common_details: KSOPCommonDetails;
};

export type AddGLIEnrollmentPayload = {
	standard_details: StandardDetails[];
	common_details: GLICommonDetails;
};

export type VEBEnrollmentPayload = {
	standard_details: VEBEnrollmentStandardDetails[];
	common_details: VEBEnrollmentCommonDetails;
	riderSSNs?: string[];
	isRider: boolean;
};

export type MemberUpdatePayload = {
	is_tobacco: boolean;
};

export type GetBenefitsQuery = {
	group_number: number;
	insured_SSN?: string;
	member_SSN?: string;
};

export const addEnrollment = async (_payload: AddEnrollmentPayload | AddKSOPEnrollmentPayload): Promise<boolean> => {
	try {
		const endpoint = `${initialRoute}/nexcaliber/add-enrollment`;
		const payload = JSON.stringify(_payload);
		const token = localStorage.getItem("@jwt_member");
		// console.log("Response1", endpoint);
		const response = await post(endpoint, payload, {
			...headers,
			Authorization: `Bearer ${token}`
		});
		// console.log("Response11", response);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succ) {
				const {
					data: { result }
				} = response;
				if (result) {
					return true;
				} else {
					return false;
				}
			}
		}
		// console.log("Response", response?.data);
		throw response?.data;
	} catch (err: any) {
		// console.log("errr", err);
		alert("Failed to add enrollment");
		throw err;
	}
};

export const addPlEnrollment = async (_payload: AddEnrollmentPayload | AddKSOPEnrollmentPayload): Promise<boolean> => {
	try {
		const endpoint = `${initialRoute}/nexcaliber/add-pl-enrollment`;
		const payload = JSON.stringify(_payload);
		const token = localStorage.getItem("@jwt_member");
		// console.log("Response1", endpoint);
		const response = await post(endpoint, payload, {
			...headers,
			Authorization: `Bearer ${token}`
		});
		// console.log("Response11", response);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succ) {
				const {
					data: { result }
				} = response;
				if (result) {
					return true;
				} else {
					return false;
				}
			}
		}
		// console.log("Response", response?.data);
		throw response?.data;
	} catch (err: any) {
		// console.log("errr", err);
		alert("Failed to add enrollment");
		throw err;
	}
};

export const addBopEnrollment = async (_payload: AddEnrollmentPayload | AddKSOPEnrollmentPayload): Promise<boolean> => {
	try {
		const endpoint = `${initialRoute}/nexcaliber/add-bop-enrollment`;
		const payload = JSON.stringify(_payload);
		const token = localStorage.getItem("@jwt_member");
		// console.log("Response1", endpoint);
		const response = await post(endpoint, payload, {
			...headers,
			Authorization: `Bearer ${token}`
		});
		// console.log("Response11", response);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succ) {
				const {
					data: { result }
				} = response;
				if (result) {
					return true;
				} else {
					return false;
				}
			}
		}
		// console.log("Response", response?.data);
		throw response?.data;
	} catch (err: any) {
		// console.log("errr", err);
		alert("Failed to add enrollment");
		throw err;
	}
};

export const updateVebEnrollment = async (_payload: any, model: string, memberId: string): Promise<any> => {
	try {
		const endpoint = `general/${model}?_id=${memberId}`;
		const payload = JSON.stringify(_payload);
		const token = localStorage.getItem("@jwt_member");
		const response = await patch(endpoint, _payload, {
			...headers,
			Authorization: `Bearer ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === "Information Updation Successful!") {
				const {
					data: { result }
				} = response;
				if (result) {
					return result;
				} else {
					return null;
				}
			}
		}
		// console.log("Response", response?.data);
		throw response?.data;
	} catch (err: any) {
		// console.log("errr", err);
		alert(err.response.data.message);
		throw err;
	}
};

export const existsVEBEnrollment = async (_payload: VEBEnrollmentPayload) => {
	try {
		const endpoint = "member/exists-member-veb-enrollment";
		const payload = JSON.stringify(_payload);
		const token = localStorage.getItem("@jwt_member");
		const response = await post(endpoint, payload, {
			...headers,
			Authorization: `Bearer ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}

		throw new Error();
	} catch (err: any) {
		throw err;
	}
};

export const addVEBEnrollment = async (_payload: VEBEnrollmentPayload): Promise<boolean> => {
	try {
		const endpoint = `${initialRoute}/VEB`;
		const payload = JSON.stringify(_payload);
		const token = localStorage.getItem("@jwt_member");
		const response = await post(endpoint, payload, {
			...headers,
			Authorization: `Bearer ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succ) {
				const {
					data: { result }
				} = response;
				if (result) {
					return true;
				} else {
					return false;
				}
			}
		}
		// console.log("Response", response?.data);
		throw response?.data;
	} catch (err: any) {
		// console.log("errr", err);
		alert(err.response.data.message);
		throw err;
	}
};

export type HOOEnrollmentQueryType = {
	insured_SSN: string;
	group_number: number;
};

export const getHOOEnrollment = async (
	HOOEnrollmentQuery: HOOEnrollmentQueryType
): Promise<EnrollmentSchema | undefined> => {
	try {
		const token = localStorage.getItem("@jwt_member");
		const endpoint = initialRoute;
		const response = await get(
			endpoint,
			{
				Authorization: `Bearer ${token}`
			},
			{ ...HOOEnrollmentQuery, plan_name: "Helping Our Own" }
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result[0];
			}
			throw new Error();
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

export const addNonOEEnrollment = async (_payload: HOOEnrollment): Promise<EnrollmentSchema> => {
	try {
		const endpoint = `${initialRoute}/non-OE-enrollment`;
		const payload = JSON.stringify(_payload);
		const token = localStorage.getItem("@jwt_member");
		const response = await post(endpoint, payload, {
			...headers,
			Authorization: `Bearer ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succ) {
				const {
					data: { result }
				} = response;
				return result[0];
			}
		}
		// console.log("Response", response?.data);
		throw response?.data;
	} catch (err: any) {
		// console.log("errr", err);
		alert(err.response.data.message);
		throw err;
	}
};

export const getBenefits = async (query: GetBenefitsQuery): Promise<Benefit[]> => {
	try {
		const endpoint = `${initialRoute}/benefits`;
		const token = localStorage.getItem("@jwt_member");
		const response = await get(
			endpoint,
			{
				...headers,
				Authorization: `Bearer ${token}`
			},
			query
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err: any) {
		if (err.response.status === 400) {
			alert(err);
		} else {
			alert(err);
		}
		throw err;
	}
};
export const getBenefitsV2 = async (query: GetBenefitsQuery): Promise<Benefit[]> => {
	try {
		const endpoint = `${initialRoute}/benefits-v2`;
		const token = localStorage.getItem("@jwt_member");
		const response = await get(
			endpoint,
			{
				...headers,
				Authorization: `Bearer ${token}`
			},
			query
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err: any) {
		if (err.response.status === 400) {
			alert(err);
		} else {
			alert(err);
		}
		throw err;
	}
};

export const getVEBBenefits = async (query: GetBenefitsQuery): Promise<VEBBenefit[]> => {
	try {
		const endpoint = `${initialRoute}/VEB/benefits`;
		const token = localStorage.getItem("@jwt_member");
		const response = await get(
			endpoint,
			{
				...headers,
				Authorization: `Bearer ${token}`
			},
			query
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err: any) {
		if (err.response.status === 400) {
			alert(err);
		} else {
			alert(err);
		}
		throw err;
	}
};

export type GETRidersQuery = {
	base_plan_name: string;
} & GetBenefitsQuery;

export const getVEBRidersByPlan = async (query: GETRidersQuery): Promise<VEBEnrollmentSchema[]> => {
	try {
		const endpoint = `${initialRoute}/VEB/benefits/riders`;
		const token = localStorage.getItem("@jwt_member");
		const response = await get(
			endpoint,
			{
				...headers,
				Authorization: `Bearer ${token}`
			},
			query
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err: any) {
		if (err.response.status === 400) {
			alert(err);
		} else {
			alert(err);
		}
		throw err;
	}
};
export type GetDependentBenefitsQuery = {
	insured_SSN: string;
	member_SSN: string;
	group_number: string | number;
};
export type GetBeneficiaryDetailsQueryType = {
	insured_SSN: string;
	base_plan_name: string;
	plan_name: string;
};

export const getBeneficiaryDetails = async (
	getBeneficiaryDetailsQuery: GetBeneficiaryDetailsQueryType
): Promise<VEBEnrollmentSchema[]> => {
	try {
		const endpoint = `${initialRoute}/VEB/active`;
		const token = localStorage.getItem("@jwt_member");
		const response = await get(
			endpoint,
			{
				...headers,
				Authorization: `Bearer ${token}`
			},
			getBeneficiaryDetailsQuery
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err: any) {
		if (err.response.status === 400) {
			alert(err);
		} else {
			alert(err);
		}
		throw err;
	}
};

export const getVEBDependentBenefits = async (
	getVEBDependentBenefitsQuery: GetDependentBenefitsQuery
): Promise<VEBEnrollmentSchema[]> => {
	try {
		const endpoint = `${initialRoute}/VEB/benefits/dependents`;
		const token = localStorage.getItem("@jwt_member");
		const response = await get(
			endpoint,
			{
				...headers,
				Authorization: `Bearer ${token}`
			},
			getVEBDependentBenefitsQuery
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err: any) {
		if (err.response.status === 400) {
			alert(err);
		} else {
			alert(err);
		}
		throw err;
	}
};

export const getDependentBenefits = async (
	getDependentBenefitsQuery: GetDependentBenefitsQuery
): Promise<EnrollmentSchema[]> => {
	try {
		const endpoint = `${initialRoute}/benefits/dependents`;
		const token = localStorage.getItem("@jwt_member");
		const response = await get(
			endpoint,
			{
				...headers,
				Authorization: `Bearer ${token}`
			},
			getDependentBenefitsQuery
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err: any) {
		if (err.response.status === 400) {
			alert(err);
		} else {
			alert(err);
		}
		throw err;
	}
};

export const getCriticalIllnessWithCancerEnrollment = async (): Promise<VEBEnrollmentSchema | null> => {
	try {
		const token = localStorage.getItem("@jwt_member");
		const endpoint = `${initialRoute}/VEB/critical-illness-with-cancer`;
		const response = await get(endpoint, {
			Authorization: `Bearer ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

export const getCancerEnrollment = async (): Promise<VEBEnrollmentSchema | null> => {
	try {
		const token = localStorage.getItem("@jwt_member");
		const endpoint = `${initialRoute}/VEB/cancer`;
		const response = await get(endpoint, {
			Authorization: `Bearer ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

export const getAccidentDisablityRiderEnrollment = async (): Promise<VEBEnrollmentSchema | null> => {
	try {
		const token = localStorage.getItem("@jwt_member");
		const endpoint = `${initialRoute}/VEB/accident-disablity-rider`;
		const response = await get(endpoint, {
			Authorization: `Bearer ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

export const getShortTermDisablityEnrollment = async (): Promise<VEBEnrollmentSchema | null> => {
	try {
		const token = localStorage.getItem("@jwt_member");
		const endpoint = `${initialRoute}/VEB/short-term-disablity`;
		const response = await get(endpoint, {
			Authorization: `Bearer ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

export const getActiveHealthPlan = async (): Promise<EnrollmentSchema | null> => {
	try {
		const token = localStorage.getItem("@jwt_member");
		const endpoint = `${initialRoute}/benefit/health-plan`;
		const response = await get(endpoint, {
			Authorization: `Bearer ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

export const getActiveDentalPlan = async (): Promise<EnrollmentSchema | null> => {
	try {
		const token = localStorage.getItem("@jwt_member");
		const endpoint = `${initialRoute}/benefit/dental-plan`;
		const response = await get(endpoint, {
			Authorization: `Bearer ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

export const getActiveVisionPlan = async (): Promise<EnrollmentSchema | null> => {
	try {
		const token = localStorage.getItem("@jwt_member");
		const endpoint = `${initialRoute}/benefit/vision-plan`;
		const response = await get(endpoint, {
			Authorization: `Bearer ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

export const getActiveClinicCard = async (): Promise<EnrollmentSchema | null> => {
	try {
		const token = localStorage.getItem("@jwt_member");
		const endpoint = `${initialRoute}/benefit/clinic-card`;
		const response = await get(endpoint, {
			Authorization: `Bearer ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

export const getActiveBeazelyClinicCardRider = async (): Promise<VEBEnrollmentSchema | null> => {
	try {
		const token = localStorage.getItem("@jwt_member");
		const endpoint = `${initialRoute}/VEB/benefit/beazely-clinic-card-rider`;
		const response = await get(endpoint, {
			Authorization: `Bearer ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

export type StackCriticalIllnessEnrollmentPayload = {
	_id: string;
	common_details: any;
	top_up_standard_premium: number;
	top_up_total_premium: number;
	increased_benefit_amount: number;
	VEB_open_enrollment_id: string;
};

export const stackCriticalIllnessEnrollment = async (_payload: StackCriticalIllnessEnrollmentPayload) => {
	try {
		const payload = JSON.stringify(_payload);
		const token = localStorage.getItem("@jwt_member");
		const endpoint = `${initialRoute}/VEB/stack-enrollment/critical-illness`;
		const response = await put(endpoint, _payload, {
			Authorization: `Bearer ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.put.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

export const stackWholeEnrollment = async (_payload: StackWholeLifeEnrollment) => {
	try {
		const payload = JSON.stringify(_payload);
		const token = localStorage.getItem("@jwt_member");
		const endpoint = `${initialRoute}/VEB/stack-enrollment/whole-life`;
		const response = await put(endpoint, _payload, {
			Authorization: `Bearer ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.put.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

export type GetActiveVEBEnrollmentsQuery = {
	insured_SSN: string;
	base_plan_name: string;
	plan_name: string;
};

export const getActiveVEBEnrollments = async (query: GetActiveVEBEnrollmentsQuery): Promise<VEBEnrollmentSchema[]> => {
	try {
		//const payload = JSON.stringify(_payload);
		const token = localStorage.getItem("@jwt_member");
		const endpoint = `${initialRoute}/VEB/active`;
		const response = await get(
			endpoint,
			{
				Authorization: `Bearer ${token}`
			},
			query
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

export const enrollment = {
	addEnrollment,
	addPlEnrollment,
	addBopEnrollment,
	getHOOEnrollment,
	addNonOEEnrollment,
	stackWholeEnrollment,
	getBenefits,
	getBenefitsV2,
	addVEBEnrollment,
	existsVEBEnrollment,
	getVEBBenefits,
	getVEBRidersByPlan,
	getDependentBenefits,
	getVEBDependentBenefits,
	getCriticalIllnessWithCancerEnrollment,
	getCancerEnrollment,
	updateVebEnrollment,
	getAccidentDisablityRiderEnrollment,
	getShortTermDisablityEnrollment,
	stackCriticalIllnessEnrollment,
	getActiveHealthPlan,
	getActiveDentalPlan,
	getActiveVisionPlan,
	getActiveClinicCard,
	getActiveBeazelyClinicCardRider,
	getBeneficiaryDetails,
	getActiveVEBEnrollments
};
